import { ConversationTagId } from "@redotech/redo-model/conversation";
import { createContext } from "react";

export const ConversationTagsContext = createContext<ConversationTagId[]>([]);
export const ReloadConversationTagsContext = createContext<() => void>(
  () => {},
);
